import React from 'react';
import {
  FileIcon,
  NotePencilIcon,
  ServicesSimpleIcon,
  TruckIcon,
} from '@fronton/icons-react';
import {
  ButtonWithGAClickButton,
  LinkWithGAClickButton,
  MeasureBenefit,
  ReviewsBenefits,
  ReviewsCatalog,
  ReviewsSection,
  Typography,
} from 'common/components';
import { reviewsLink } from 'common/components/reviews-section';
import { fullWidthMobileButton } from 'common/styles/common';
import { REVIEWS_DATA } from './storage-review-constants';

/**
 * Вью лендинга Спасео Куб
 */
export const StorageReview: React.FC<{ elementBlock: string; signLink: string }> = ({ elementBlock, signLink }) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits
        benefitsList={[
          {
            icon: NotePencilIcon,
            text: <MeasureBenefit elementBlock={elementBlock} href={signLink} />,
          },
          {
            icon: FileIcon,
            text: 'Подготовим\nдизайн-проект',
          },
          {
            icon: TruckIcon,
            text: 'Доставим\nдо вашего дома',
          },
          {
            icon: ServicesSimpleIcon,
            text: 'Соберём\nи установим',
          },
        ]}
        newVariant
      />
    }
    review={
      <ReviewsCatalog
        elementBlock={elementBlock}
        modalButton={
          <ButtonWithGAClickButton
            className={fullWidthMobileButton}
            elementBlock={`${elementBlock} / Reviews`}
            elementName="Отзывы клиентов"
            elementText="Записаться на проектирование"
            title="Запишитесь на проектирование"
            href={signLink}
            target="_blank"
            variant="accent"
            wide>
            Записаться на проектирование
          </ButtonWithGAClickButton>
        }
        newVariant
        reviewsList={REVIEWS_DATA}
      />
    }
    description="Делаем кухни, которые хочется показывать"
    title={<>
      <LinkWithGAClickButton
        className={reviewsLink}
        elementBlock={`${elementBlock} / Reviews`}
        elementName="Отзывы клиентов"
        elementText="Запишитесь"
        title="Запишитесь на проектирование"
        href={signLink}
        target="_blank">
        <Typography variant="h2" color="text-invert">
          Запишитесь
        </Typography>
      </LinkWithGAClickButton>{' '}
      на&nbsp;бесплатное проектирование, <span>а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах!</span>
    </>
    }
  />
);
